<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi"><a id="page_v"></a><em class="italic">To the memory of the real G.K. George, master story teller</em><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Dedi.vue?017fec3b